export default __webpack_public_path__ + "static/media/statistics.fca6499d.svg";